import * as firebase from 'firebase';

const prodConfig = {
    apiKey: "AIzaSyAzxvq8nkKUW8T1wXDq0JYaU8UOjdlzOMA",
    authDomain: "seco-ai.firebaseapp.com",
    databaseURL: "https://seco-ai.firebaseio.com",
    projectId: "seco-ai",
    storageBucket: "seco-ai.appspot.com",
    messagingSenderId: "600632768248"
    };

const devConfig = {
    apiKey: "AIzaSyBpE72JHnF0TnDWopgXbvvJ7MS1laoixe0",
    authDomain: "dev-seco-ai.firebaseapp.com",
    databaseURL: "https://dev-seco-ai.firebaseio.com",
    projectId: "dev-seco-ai",
    storageBucket: "dev-seco-ai.appspot.com",
    messagingSenderId: "273882332276"
    };

const config = process.env.NODE_ENV === 'production'
    ? prodConfig
    : devConfig;

  if (!firebase.apps.length) {
    firebase.initializeApp(config);

    /*firebase.auth().onAuthStateChanged(function(user) {
        if(!user.emailVerified) user.sendEmailVerification(); 
      });*/
  }

const auth = firebase.auth();

export {
  auth,
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js